<template>
  <ul v-if="isLoading">
    <DpplListItem
      v-for="(_, i) in Array(numberToLoad)"
      :key="i"
    >
      <template #left>
        <div
          class="d-flex pl-2"
          style="width: 470px; max-width: 100%; height: 50px;"
        >
          <v-skeleton-loader
            :loading="false"
            :type="isRequisition ? 'list-item' : 'list-item-avatar-two-line'"
            width="100%"
            height="50px"
            class="left-side-loader"
          />
        </div>
      </template>
      <template #right>
        <div class="right-section pl-16">
          <v-skeleton-loader
            :loading="false"
            type="text"
            height="13px"
            width="58px"
          />
        </div>
        <div class="right-section">
          <v-skeleton-loader
            :loading="false"
            type="text"
            width="50"
            height="13"
          />
        </div>
        <div
          v-if="isRequisition"
          class="right-section"
        >
          <v-skeleton-loader
            :loading="false"
            type="text"
            width="145"
            height="13"
          />
        </div>
      </template>
      <template #menu-contents>
        <div v-if="!isRequisition" />
      </template>
    </DpplListItem>
  </ul>
</template>

<script>
import DpplListItem from '@/components/datapeople/DpplListItem.vue';

export default {
  name: 'DocumentListLoader',
  components: {
    DpplListItem,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    numberToLoad: {
      type: Number,
      default: 9,
    },
    isRequisition: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.right-section {
  padding: 0 24px;
  border-left: 2px solid @stroke-default;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.menu-container:hover) {
  cursor: progress;
}

:deep(.menu-container:hover .v-icon) {
  color: @grey-500;
}

:deep(.dppl-list-item:hover) {
  box-shadow: none;
  cursor: progress;
}

.left-side-loader :deep(.v-skeleton-loader__list-item-avatar-two-line) {
  height: 50px;
  align-items: flex-start;
}

.left-side-loader :deep(.v-skeleton-loader__avatar) {
  height: 50px;
  min-height: 50px;
  max-height: 50px;
  width: 50px;
  min-width: 50px;
  max-height: 50px;
  margin: 0px 16px;
}

.left-side-loader :deep(.v-skeleton-loader__text) {
  &:nth-child(1) {
    margin: 10px 16px 8px 16px;
  }

  &:nth-child(2) {
    margin: 0px 16px 8px 16px;
  }
}

.right-section :deep(.v-skeleton-loader__text) {
  margin: 8px 0px 16px 0px;
}
</style>
